// extracted by mini-css-extract-plugin
module.exports = {"slide":"games-preview_slide__BN7jQ","providers_list":"games-preview_providers_list__cSmTp"};